<template>
  <b-modal
    hide-footer
    style="z-index: 99999;margin-top: 100px;"
    id="order-received"
    size="lg"
    title="Prepare an order"
  >
    <div v-if="selectedOrder != null && selectedOrder.order">
      <vs-row vs-w="12">
        <vs-col vs-justify="center" vs-align="center" vs-w="8">
          <h1>#{{ selectedOrder.order.unique_id }}</h1>
          <vs-row class="mt-3">
            <vs-col vs-w="4">Name :</vs-col>
            <vs-col vs-w="8"
              >{{ selectedOrder.order.name.first }}
              {{ selectedOrder.order.name.last }}</vs-col
            >
          </vs-row>
          <vs-row class="mt-3">
            <vs-col vs-w="4">Email :</vs-col>
            <vs-col vs-w="8">{{ selectedOrder.order.email }}</vs-col>
          </vs-row>
          <vs-row class="mt-3">
            <vs-col vs-w="4">Mobile :</vs-col>
            <vs-col vs-w="8">{{ selectedOrder.order.phone }}</vs-col>
          </vs-row>
          <vs-row class="mt-3">
            <vs-col vs-w="4">IP Address :</vs-col>
            <vs-col vs-w="8">{{ selectedOrder.order.ipaddress }}</vs-col>
          </vs-row>
          <vs-row class="mt-3">
            <vs-col vs-w="4">Upload Date :</vs-col>
            <vs-col vs-w="8">{{ selectedOrder.order.upload_date }}</vs-col>
          </vs-row>
        </vs-col>
        <vs-col vs-justify="center" vs-align="center" vs-w="4">
          <vs-image :src="`https://picsum.photos/400/400?image=21`" />
        </vs-col>
      </vs-row>

      <!-- <template v-if="selectedOrder.related_orders.length > 0">
        <vs-table class="mt-5" stripe :data="selectedOrder.related_orders">
          <template slot="thead">
            <vs-th>Order</vs-th>
            <vs-th>Name</vs-th>
            <vs-th>Email</vs-th>
            <vs-th>Mobile</vs-th>
            <vs-th>Level</vs-th>
            <vs-th>View</vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr
              :key="indextr"
              v-for="(tr, indextr) in selectedOrder.related_orders"
            >
              <vs-td :data="data[indextr].unique_id">{{
                data[indextr].unique_id
              }}</vs-td>
              <vs-td :data="data[indextr].name"
                >{{ data[indextr].name.first }}
                {{ data[indextr].name.last }}</vs-td
              >

              <vs-td :data="data[indextr].email">{{
                data[indextr].email
              }}</vs-td>

              <vs-td :data="data[indextr].phone">{{
                data[indextr].phone
              }}</vs-td>
              <vs-td :data="data[indextr].level"></vs-td>
              <vs-td :data="data[indextr].level"></vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </template> -->
      <vs-row class="mt-5" vs-w="12">
        <vs-col vs-justify="center" vs-align="center" vs-w="12">
          <vs-textarea
            :disabled="true"
            class="w-full"
            v-model="selectedOrder.order.remark"
          />
        </vs-col>
      </vs-row>

      <vs-row class="mt-5" vs-w="12">
        <vs-col vs-justify="center" vs-align="center" vs-w="12">
          <vs-button style="width: 100%" @click="onAction('preparing')"
            >Prepare Order</vs-button
          >
        </vs-col>
      </vs-row>
    </div>
  </b-modal>
</template>
<script>
import Service from "@/services";

export default {
  components: {},
  name: "order-received-dialog",
  props: {
    order: null,
  },
  computed: {
    selectedOrder: {
      get() {
        return this.order;
      },
      set() {},
    },
  },
  methods: {
    onAction(type) {
      let data = {
        e: this.$route.query.e,
        order_id: this.selectedOrder.order.order_id,
        action: type,
        remark: "",
      };

      Service.Order.action(data)
        .then(() => {
          this.$vs.notify({
            title: "Success",
            text: "Update complete.",
            color: "success",
          });

          this.$emit("close");
        })
        .catch((err) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Oops!",
            text: "ERROR : " + err.error,
            color: "danger",
          });
        });
    },
  },
};
</script>
